import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, InjectionToken, Injector, OnInit, PLATFORM_ID, runInInjectionContext, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { PermissionNamesEnum } from '@server/services/cbox/public/api/v1/enforcers/entity_permission/types';
import { TabMenuModule } from 'primeng/tabmenu';
import { PermissionDirective } from 'src/directives/permission.directive';
import { RedirectToRouteThatHasAccess } from 'src/guards/permission.guard';
import { Routes } from 'src/services/configuration/configuration.service';

@Component({
  selector: 'app-cbox-profile-finance-repayments-container',
  templateUrl: './cbox-profile-finance-repayments-container.component.html',
  styleUrls: ["./cbox-profile-finance-repayments-container.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    TabMenuModule,

    PermissionDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CBoxProfileFinanceRepaymentsContainerComponent implements OnInit {
  tabMenuItems = signal<Routes[]>([
    {
      label: "Comenzi plătite",
      routerLink: "./orders/paid",
      link: "./orders/paid",
      icon: "receipt_long",
      rights: [PermissionNamesEnum.viewReports],
    },
    {
      label: "Comenzi neplătite",
      routerLink: "./orders/unpaid",
      link: "./orders/unpaid",
      icon: "receipt_long",
      rights: [PermissionNamesEnum.viewReports],
    },
    {
      label: "Borderouri trimise",
      routerLink: "./sheets",
      link: "./sheets",
      icon: "receipt_long",
      rights: [PermissionNamesEnum.viewReports],
    }
  ]);

  constructor(
    private router: Router,
    private inj: Injector,
    @Inject(PLATFORM_ID) private platformId: InjectionToken<Object>
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.pipe(takeUntilDestroyed())
        .subscribe((event) => {
          if (
              event instanceof NavigationEnd &&
              this.router.url.endsWith("/finance/repayments")
            ) {
              runInInjectionContext(this.inj, () => {
                RedirectToRouteThatHasAccess(
                  "/profile/finance/repayments",
                  this.tabMenuItems()
                );
              });
            }
        });
      }
  }

  ngOnInit() { }
}